"use strict";
import { ChainSelector } from "components/NavBar/ChainSelector";
import { CompanyMenu } from "components/NavBar/CompanyMenu";
import { PreferenceMenu } from "components/NavBar/PreferencesMenu";
import { useTabsVisible } from "components/NavBar/ScreenSizes";
import { SearchBar } from "components/NavBar/SearchBar";
import { Tabs } from "components/NavBar/Tabs/Tabs";
import TestnetModeTooltip from "components/NavBar/TestnetMode/TestnetModeTooltip";
import Web3Status from "components/Web3Status";
import Row from "components/deprecated/Row";
import { useAccount } from "hooks/useAccount";
import { PageType, useIsPage } from "hooks/useIsPage";
import deprecatedStyled, { css } from "lib/styled-components";
import { Flex, Nav as TamaguiNav, styled, useMedia } from "ui/src";
import { INTERFACE_NAV_HEIGHT, breakpoints, zIndexes } from "ui/src/theme";
import { useEnabledChains } from "uniswap/src/features/chains/hooks/useEnabledChains";
import { FeatureFlags } from "uniswap/src/features/gating/flags";
import { useFeatureFlag } from "uniswap/src/features/gating/hooks";
const UnpositionedFlex = styled(Flex, {
  position: "unset"
});
const Nav = styled(TamaguiNav, {
  position: "unset",
  px: "$padding12",
  width: "100%",
  height: INTERFACE_NAV_HEIGHT,
  zIndex: zIndexes.sticky,
  justifyContent: "center"
});
const NavItems = css`
  gap: 12px;
  @media screen and (max-width: ${breakpoints.md}px) {
    gap: 4px;
  }
`;
const Left = deprecatedStyled(Row)`
  display: flex;
  align-items: center;
  wrap: nowrap;
  ${NavItems}
`;
const Right = deprecatedStyled(Row)`
  justify-content: flex-end;
  ${NavItems}
`;
function useShouldHideChainSelector() {
  const isLandingPage = useIsPage(PageType.LANDING);
  const isSendPage = useIsPage(PageType.SEND);
  const isSwapPage = useIsPage(PageType.SWAP);
  const isWrapPage = useIsPage(PageType.WRAP);
  const isLimitPage = useIsPage(PageType.LIMIT);
  const isExplorePage = useIsPage(PageType.EXPLORE);
  const isPositionsPage = useIsPage(PageType.POSITIONS);
  const isMigrateV3Page = useIsPage(PageType.MIGRATE_V3);
  const isBuyPage = useIsPage(PageType.BUY);
  const isSellPage = useIsPage(PageType.SELL);
  const isReferralPage = useIsPage(PageType.REFERRAL);
  const multichainHiddenPages = isLandingPage || isSendPage || isSwapPage || isWrapPage || isLimitPage || isExplorePage || isPositionsPage || isMigrateV3Page || isBuyPage || isSellPage || isReferralPage;
  return multichainHiddenPages;
}
export default function Navbar() {
  const media = useMedia();
  const isSmallScreen = media.md;
  const areTabsVisible = useTabsVisible();
  const collapseSearchBar = media.xl;
  const account = useAccount();
  const NAV_SEARCH_MAX_HEIGHT = "calc(100vh - 30px)";
  const hideChainSelector = useShouldHideChainSelector();
  const isExplorePage = useIsPage(PageType.EXPLORE);
  const showNavBarSearch = useFeatureFlag(FeatureFlags.ShowNavBarSearch);
  const shouldShowSearchBar = isExplorePage || showNavBarSearch;
  const { isTestnetModeEnabled } = useEnabledChains();
  return <Nav><UnpositionedFlex row centered width="100%"><Left><CompanyMenu />{areTabsVisible && <Tabs />}</Left>{!collapseSearchBar && shouldShowSearchBar && <SearchBar maxHeight={NAV_SEARCH_MAX_HEIGHT} fullScreen={isSmallScreen} />}<Right>{collapseSearchBar && shouldShowSearchBar && <SearchBar maxHeight={NAV_SEARCH_MAX_HEIGHT} fullScreen={isSmallScreen} />}{
    /* {!isEmbeddedWalletEnabled && isLandingPage && !isSmallScreen && <NewUserCTAButton />} */
  }{!account.isConnected && !account.isConnecting && <PreferenceMenu />}{!hideChainSelector && <ChainSelector />}{isTestnetModeEnabled && <TestnetModeTooltip />}{
    /* {isEmbeddedWalletEnabled && !account.address && <NewUserCTAButton />} */
  }<Web3Status /></Right></UnpositionedFlex></Nav>;
}
